import { useTranslation } from "react-i18next";
import { isValidInstagramHandle } from "../../../utils/instagram";
import InputColor from "../../dashboard/settings/branding/InputColor";
import MultiOptionsInput from "../../dashboard/settings/branding/MultiOptionsInput";
import ThemeSelector from "../../dashboard/settings/branding/ThemeSelector";
import StepHeading from "./StepHeading";

// Step 4 — branding (theme + colors). Reuses the dashboard branding inputs,
// which render their own hidden form fields for submission.
const StepBranding = ({
  current,
  state,
  mobile,
  onThemeChange,
  onWebThemeChange,
  onColorChange,
  onTextColorChange,
  onInstagramChange,
}) => {
  const { t } = useTranslation("auth");
  const instagramInvalid =
    !!state.instagramHandle && !isValidInstagramHandle(state.instagramHandle);

  return (
    <div className="step-body step-branding">
      <StepHeading
        current={current}
        title={t("onboardingWizard.branding.title")}
        subtitle={t("onboardingWizard.branding.subtitle")}
      />

      {/* Two columns: mobile theme + app colors | web theme + Instagram, so
          both columns stay about the same height. */}
      <div className="branding-grid">
        <div className="branding-col branding-col-mobile">
          <div className="theme-group">
            <span className="theme-group-label">
              {t("onboardingWizard.branding.mobileApp")}
            </span>
            <ThemeSelector
              inputName="appTheme"
              value={state.appTheme}
              onChange={onThemeChange}
              boxSmall
              selectedBorder
              label={t("onboardingWizard.branding.theme")}
            />
          </div>

          <div className="primary-color-wrapper">
            <h3>{t("onboardingWizard.branding.primaryColor")}</h3>
            <InputColor
              mobile={mobile}
              inputName="appMainColor"
              inputNameColor="appMainColorPicker"
              value={state.appMainColor}
              onChange={onColorChange}
            />

            <h3 className="mt-8">{t("onboardingWizard.branding.textColor")}</h3>
            <MultiOptionsInput
              value={state.appSecondaryTextColor}
              inputName="appSecondaryTextColor"
              onChange={onTextColorChange}
              options={["black", "white"]}
              optionLabels={{
                white: t("onboardingWizard.branding.white"),
                black: t("onboardingWizard.branding.black"),
              }}
            />
          </div>
        </div>

        <span className="apptheme-separator" aria-hidden="true" />

        <div className="branding-col branding-col-web">
          <div className="theme-group">
            <span className="theme-group-label">
              {t("onboardingWizard.branding.webApp")}
            </span>
            <ThemeSelector
              inputName="webAppTheme"
              value={state.webAppTheme}
              onChange={onWebThemeChange}
              boxSmall
              selectedBorder
              label={t("onboardingWizard.branding.theme")}
              isStorefront
            />
          </div>

          <div className="instagram-field">
            <label htmlFor="instagramHandle">
              {t("onboardingWizard.branding.instagram")}
              <span>{t("onboardingWizard.branding.optional")}</span>
            </label>
            <p className="instagram-help">
              {t("onboardingWizard.branding.instagramHelp")}
            </p>
            <div className="instagram-input">
              <span aria-hidden="true">@</span>
              <input
                id="instagramHandle"
                name="instagramHandle"
                type="text"
                className="text-input"
                sz="large"
                autoComplete="off"
                placeholder={t(
                  "onboardingWizard.branding.instagramPlaceholder"
                )}
                value={state.instagramHandle}
                onChange={onInstagramChange}
                data-has-error={instagramInvalid}
              />
            </div>
            {instagramInvalid ? (
              <p className="error">
                {t("onboardingWizard.branding.instagramInvalid")}
              </p>
            ) : (
              <p className="instagram-preview">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.5" />
                </svg>
                instagram.com/
                {state.instagramHandle ||
                  t("onboardingWizard.branding.instagramPlaceholder")}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepBranding;
